// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const activitySchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  entityType: z.string().max(50),
  entityId: z.string().max(100),
  entityName: z.string().max(200),
  action: z.string().max(50),
  userName: z.string().max(200),
  productId: z.string().max(100).optional(),
  changes: z.record(z.string(), z.unknown()).optional(),
  tenantId: z.string().max(100).optional(),
})

export type ActivityInput = z.infer<typeof activitySchema>
